var exports = {
  "kL": "x936d19a0--ef4f0f--container",
  "Hw": "x936d19a0--ef4f0f--mobile",
  "tA": "x936d19a0--ef4f0f--submit",
  "Kq": "x936d19a0--ef4f0f--agreements",
};

module.exports = exports;
